module.exports = __webpack_public_path__ + "img/soja.4e8a3eee.svg";